<script setup lang="ts">
import ChatMessageTemplateTable, {
  type ChatMessageTemplateTableForm,
} from './ChatMessageTemplateTable.vue'
import { ref } from 'vue'
import { useAlert } from '@/libs/alertPortal'
import { useRouter, onBeforeRouteLeave } from 'vue-router'
import { captureException } from '@sentry/vue'
import { useSettingsPageAddChatMessageTemplateMutation } from './SettingsPageChatMessageTemplateCreateView.generated'
import SettingsPagePanel from '../SettingsPagePanel.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'

const emit = defineEmits<{
  (
    event: 'onBeforeLeaveConfirmation',
    callbacks: { onConfirm: () => void; onAbort: () => void }
  ): void
}>()

const isCompleted = ref(false)

const form = ref<ChatMessageTemplateTableForm>({
  label: '',
  body: '',
  selections: [],
})

const { mutate: addChatMessageTemplate } =
  useSettingsPageAddChatMessageTemplateMutation({})

onBeforeRouteLeave((to, from, next) => {
  if (from.name !== 'chatMessageTemplateNew') {
    next()
    return
  }
  if (to.name === 'chatMessageTemplate' && !isCompleted.value) {
    next()
    return
  }
  emit('onBeforeLeaveConfirmation', {
    onConfirm: () => {
      isCompleted.value = true
      next()
    },
    onAbort: () => next(false),
  })
})

const alert = useAlert()

const router = useRouter()

const handleSave = async (input: ChatMessageTemplateTableForm) => {
  try {
    await addChatMessageTemplate({
      input: {
        label: input.label,
        body: input.body,
        selections: input.selections,
      },
    })
    alert.success('チャットメッセージテンプレートを作成しました')
    // eslint-disable-next-line fp/no-mutating-methods
    await router.push({
      name: 'chatMessageTemplate',
    })
  } catch (e) {
    captureException(e)
    console.error(e)
    alert.error(
      'エラーが発生しました。再度お試しいただくか、サポートにお問い合わせください。'
    )
  }
}
</script>

<template>
  <SettingsPagePanel>
    <SettingsPagePanelHeader>
      <template #title>チャットメッセージテンプレート 新規作成</template>
    </SettingsPagePanelHeader>
    <ChatMessageTemplateTable :form="form" @save="handleSave" />
  </SettingsPagePanel>
</template>
